import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../../UI';
import { PersonFormValues } from '../types';

type PersonGivenNameInputProps = Pick<InputProps, 'label' | 'className'> &
  InputProps['inputProps'];

export const PersonGivenNameInput: FC<PersonGivenNameInputProps> = ({
  label,
  className,
  ...inputProps
}) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<PersonFormValues>();

  return (
    <Input
      className={className}
      {...register('givenName', { required: true })}
      status={errors.givenName ? 'errored' : 'normal'}
      label={label ?? tForm('person-given-name-input-label')}
      inputProps={{
        placeholder: tForm('general-required-placeholder'),
        ...inputProps,
      }}
    />
  );
};
